import type { AccountsItem, Organization } from 'types/api/responses/enterprise'
import type { UserProfileResponseType } from 'types/api/responses/profiles'
import type { SenderID } from 'types/api/responses/senderIds'

export const CHAT_SASA_MAX_SENDER_IDS = 20

declare global {
	interface Window {
		ChatSasa?: {
			setUserData: (data: ChatSasaUserData) => void
			clearUserData: () => void
		}
	}
}

export type ChatSasaUserData = {
	user_id: string
	user_name: string
	user_email: string
	context: {
		source: 'smsleopard'
		phone_number: string
		customer_since: string
		account_name: string
		organization_name: string
		sender_ids: Array<{
			name: string
			type: string
		}>
	}
}

export function clearChatSasaUserDataWhenReady(): () => void {
	const clearUserData = () => window.ChatSasa?.clearUserData()

	clearUserData()
	window.addEventListener('chatsasa:ready', clearUserData)

	return () => window.removeEventListener('chatsasa:ready', clearUserData)
}

export function buildChatSasaUserData({
	profile,
	account,
	organization,
	senderIDs = [],
}: {
	profile: UserProfileResponseType
	account?: AccountsItem
	organization?: Organization
	senderIDs?: SenderID[]
}): ChatSasaUserData {
	const profilePhone = profile.phone?.trim()
	const structuredPhone = `${profile.phone_number?.country_code || ''}${profile.phone_number?.number || ''}`.trim()

	return {
		user_id: profile.username,
		user_name: `${profile.first_name || ''} ${profile.last_name || ''}`.trim(),
		user_email: profile.email,
		context: {
			source: 'smsleopard',
			phone_number: profilePhone || structuredPhone,
			customer_since: profile.created_at,
			account_name: account?.name || '',
			organization_name: organization?.name || account?.organization_name || '',
			sender_ids: senderIDs.slice(0, CHAT_SASA_MAX_SENDER_IDS).map(senderID => ({
				name: senderID.name,
				type: senderID.sender_id_type,
			})),
		},
	}
}
